@if (this.tiles().length > 0) {
  <div class="attachments flex-column g-space-sm">
    <div class="attachments__header flex-row align-center g-space-sm c-pointer" (click)="this.toggleCollapsed()">
      <cam-font-icon name="attach" type="xs"></cam-font-icon>
      <cam-text size="sm" [isBold]="true">
        {{ 'communication.message.attachments.title' | translate }}
      </cam-text>
      <cam-text size="sm" color="brand-secondary">
        {{ this.tiles().length }}
      </cam-text>
      @if (!this.collapsed() && this.totalSize() > 0) {
        <cam-text size="sm" color="brand-secondary">
          {{ this.totalSize() | fileSize }}
        </cam-text>
      }

      <cam-button-tool
        class="attachments__toggle"
        size="xs"
        [icon]="this.collapsed() ? 'arrow-big-bottom' : 'arrow-big-top'"
        (action)="this.toggleCollapsed()"
      ></cam-button-tool>
    </div>

    <div class="attachments__list grid-one-fourth grid-md-one-half g-space-sm" [hidden]="this.collapsed()">
      @for (tile of this.tiles(); track tile.value.id) {
        <div class="attachment">
          <cam-file-display-card
            [file]="tile.document"
            (fileSelected)="this.openPreview($event)"
          ></cam-file-display-card>

          @if (!this.readonly()) {
            <cam-button-tool
              class="attachment__remove"
              icon="close"
              size="xs"
              (action)="this.remove.emit(tile.value)"
            ></cam-button-tool>
          }
        </div>
      }
    </div>
  </div>
}

<cam-layout-full-panel
  [toggleState]="this.previewModal.open()"
  (closeEvent)="this.previewModal.open.set(false)"
  title="communication.attachments.preview-title"
  type="modal"
  size="lg"
  orientation="vertical"
>
  @if (this.previewModal.open()) {
    <cam-files-slide
      [initial]="this.previewModal.input()?.initial ?? null"
      [files]="this.previewModal.input()?.files ?? []"
    ></cam-files-slide>
  }
</cam-layout-full-panel>
